<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">产品</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">虚拟主机</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="se-panel-title">虚拟主机列表</div>
      </div>
      <div class="panel-body clearfix">
        <div class="ub-box z-margin-bottom-20-precent">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="BuyVhost">购买</el-button>
          <div class="zj-select" style="margin-left: 25px">
            <el-input placeholder="关键词" v-model="search" class="input-with-select" @keyup.enter.native="SearchVhost">
              <el-select v-model="key_type" slot="prepend" placeholder="全部">
                <el-option label="FTP账号" value="ftp"></el-option>
                <el-option label="主机IP" value="ip"></el-option>
                <el-option label="域名" value="domainname"></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-search" @click="SearchVhost"></el-button>
            </el-input>
          </div>
        </div>
        <el-table :data="vhostList" highlight-current-row show-header v-loading="listLoading" class="table-empty" @sort-change="sort" style="width: 100%;">
          <el-table-column prop="date" label="网站域名" min-width="200" align="left">
            <template slot-scope="scope">
              <p class="z-lineHeight-18" v-if="scope.row.domainname.length > 0 && scope.row.Pstate != '0'"><a class="z-color-a a-underline-link" :href="'http://'+ [...scope.row.domainname.filter(item => '0' === item.id)][0].DomainName" target="_blank">http://{{[...scope.row.domainname.filter(item => '0' === item.id)][0].DomainName}}</a></p>
              <p class="z-lineHeight-18" v-if="scope.row.domainname.length > 0 && scope.row.Pstate != '0' && option.id != 0 && index < 2" v-for="(option,index) in scope.row.domainname"><a class="z-color-a a-underline-link" :href="'http://'+ option.DomainName" target="_blank">http://{{option.DomainName}}</a></p>
              <el-button type="primary" size="mini" v-if="scope.row.Pstate === '0'" @click="HostInit(scope.row.id)">点击一键初始化</el-button>
              <i v-if="scope.row.free === 'free'" class="vhost-free"></i>
            </template>
          </el-table-column>
          <el-table-column prop="caiwu_type" label="网站配置" min-width="400" align="left">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="8">网站空间：<span class="z-color-green z-font-weight-700">{{scope.row.websize}}</span></el-col>
                <el-col :span="8">IP地址：<span class="z-color-green z-font-weight-700">{{scope.row.ip_type}}（{{scope.row.ip}}）</span></el-col>
                <el-col :span="8">MySql数据库：<span class="z-color-green z-font-weight-700">{{scope.row.mysql}}</span></el-col>
              </el-row>
              <el-row>
                <el-col :span="8">语言环境：<span class="z-color-green z-font-weight-700">{{scope.row.system}}</span></el-col>
                <el-col v-if="scope.row.ip_type === '独享'" :span="8">&nbsp;&nbsp;&nbsp;带宽：<span class="z-color-green z-font-weight-700">{{scope.row.daikuan}}</span></el-col>
                <el-col v-if="scope.row.ip_type === '共享'" :span="8">月流量：<span class="z-color-green z-font-weight-700">{{scope.row.liuliang}}</span></el-col>
                <el-col :span="8">MsSql数据库：<span class="z-color-green z-font-weight-700">{{scope.row.mssql}}</span></el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="StartTime" label="开通时间" align="left" sortable="custom">
          </el-table-column>
          <el-table-column prop="EndTime" label="到期时间" align="left" sortable="custom">
            <template slot-scope="scope">
              <span :class="{'z-color-red': scope.row.EndTime === '终身有效'}">{{scope.row.EndTime}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cost_type" label="操作" align="center">
            <template slot-scope="scope">
              <router-link v-if="scope.row.Pstate != '0'" :to="'/vhost'+'/'+scope.row.id" class="z-color-a">管理</router-link>
              &nbsp;&nbsp;
              <span v-if="scope.row.Pstate != '0' && scope.row.EndTime != '终身有效' && scope.row.free != 'free'" class="z-curPonit z-color-a" @click="Rennew(scope.row.id,scope.row.EndTime)">续费</span>
              <router-link v-if="scope.row.Pstate != '0' && scope.row.EndTime != '终身有效' && scope.row.free === 'free'" class="z-curPonit z-color-a" to="/vhostDelay">免费延期</router-link>
              &nbsp;&nbsp;
              <span v-if="scope.row.Pstate != '0' && scope.row.EndTime != '终身有效' && scope.row.free != 'free'" class="z-curPonit z-color-a" @click="Shengji(scope.row.id,scope.row.EndTime,scope.row.websize,scope.row.daikuan,scope.row.mysql,scope.row.mssql)">升级</span>
            </template>
          </el-table-column>
          <span slot="empty">
            虚拟主机列表为空，
            <a class="z-curPonit z-color-a" href="/vhost/" target="_blank">立即购买&gt;&gt;</a>
          </span>
        </el-table>
        <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="10" :total="total" class="pull-left">
        </el-pagination>
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="云虚拟主机续费" :lock-scroll="false" :visible.sync="dialogXufei" @close="xufeiForm.region = '1'" width="660px">
      <el-form label-width="180px" class="xufei-form">
        <el-form-item label="产品名称：" size="mini">
          <span class="z-font-size-12 z-color-666">{{xufeiForm.name}}</span>
        </el-form-item>
        <el-form-item label="ftp账号：">
          <span class="z-font-size-12 z-color-666">{{xufeiForm.ftp}}</span>
        </el-form-item>
        <el-form-item label="到期时间：">
          <span class="z-font-size-12 z-color-666">{{xufeiForm.endtime}}</span>
        </el-form-item>
        <el-form-item label="续费时长：">
          <el-select v-model="xufeiForm.region">
            <el-option label="1年" value="1"></el-option>
            <el-option label="2年" value="2"></el-option>
            <el-option label="3年" value="3"></el-option>
            <el-option label="4年" value="4"></el-option>
            <el-option label="5年" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优惠券：">
          <el-select v-model="xufeiForm.coupon" placeholder="--请选择--" style="width: 300px">
            <el-option
              v-for="item in xufeiForm.yhq"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="续费后到期时间：">
          <span class="z-font-size-12 z-color-666">{{xufeiForm.newtime}}</span>
        </el-form-item>
        <el-form-item label="账户余额：">
          <span class="z-font-size-12 z-color-66-orange z-font-weight-700">{{xufeiForm.money}}元</span>
        </el-form-item>
        <el-form-item label="所需费用：">
          <span v-show="xufeiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">价格计算中...</span>
          <span v-show="!xufeiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">{{xufeiForm.price}}.</span>
          <span v-show="!xufeiForm.loading" class="z-font-size-12 z-color-66-orange">00元</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogXufei = false">取 消</el-button>
        <el-button type="primary" @click="Renew">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="云虚拟主机升级" :lock-scroll="false" :visible.sync="dialogXLevel" width="660px">
      <el-form label-width="140px" class="xufei-form">
        <el-form-item label="当前配置：">
          <span class="z-font-size-12 z-color-666">网站空间（{{shengjiForm.websize}}）MySql（{{shengjiForm.mysql}}）MsSql（{{shengjiForm.mssql}}）带宽（{{shengjiForm.daikuan}}）</span>
        </el-form-item>
        <el-form-item label="升级的套餐名称：">
          <el-radio-group v-model="shengjiForm.type" size="small" @change="changeConfig">
            <el-radio-button v-for="(item, index) in shengjiForm.config"
                             :key="index"
                             :label="item.value">{{item.label}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="升级后配置：">
          <span v-for="option in shengjiForm.pset" class="z-font-size-12 z-color-666">{{option}}</span>
        </el-form-item>
        <el-form-item label="优惠券：">
          <el-select v-model="shengjiForm.coupon" placeholder="--请选择--" style="width: 300px">
            <el-option
              v-for="item in shengjiForm.yhq"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到期时间：">
          <span class="z-font-size-12 z-color-666">{{shengjiForm.endtime}}</span>
        </el-form-item>
        <el-form-item label="账户余额：">
          <span class="z-font-size-12 z-color-66-orange z-font-weight-700">{{shengjiForm.money}}元</span>
        </el-form-item>
        <el-form-item label="所需费用：">
          <span v-show="shengjiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">价格计算中...</span>
          <span v-show="!shengjiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">{{shengjiForm.price}}.</span>
          <span v-show="!shengjiForm.loading" class="z-font-size-12 z-color-66-orange">00元</span>
        </el-form-item>
      </el-form>
      <div class="alert-warn alert-white-bg">
        <div class="alert-warn-title">
          说明
        </div>
        <div>
          1. 云虚拟主机升级后，到期时间不变，升级的差价计算精确到天；
        </div>
        <div>
          2. 升级/降级费用最低10元起，不足10元的按10元；
        </div>
        <div>
          3. 升级价格计算公式：(升级配置价格[年] - 原始配置价格[年]) / 365 * 到期剩余天数；
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogXLevel = false">取 消</el-button>
        <el-button type="primary" @click="Level">确 定</el-button>
      </div>
    </el-dialog>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import vhostService from 'business/vhostService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import userService from 'business/userService.js'
  import renewService from 'business/renewService.js'
  import upgradeService from 'business/upgradeService.js'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        vhostList:[],
        dialogLoading:false,
        listLoading:false,
        showempty:false,
        dialogXufei:false,
        dialogXLevel:false,
        activeNames:'index',
        input:'',
        userList: [],
        search:'',
        key_type:'ftp',
        orderby:'StartTime',
        ordertype:'desc',
        xufeiForm:{
          id:'',
          name:'',
          ftp:'',
          endtime:'',
          region: '1',
          coupon:'',
          yhq:[],
          newtime:'',
          price:'',
          loading:false,
          money:''
        },
        shengjiForm:{
          websize:'',
          daikuan:'',
          subweb:'',
          mysql:'',
          mssql:'',
          id:'',
          type:'',
          config:[],
          pset:[],
          coupon:'',
          yhq:[],
          endtime:'',
          price:'',
          loading:false,
          money:''
        },
        count:10,
        total:0,
        page:1,
      }
    },
    components:{
      XdialogLoading,
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.SearchVhost()
    },
    computed: {
      region() {
        return this.xufeiForm.region
      },
      coupon() {
        return this.xufeiForm.coupon
      },
      coupon2() {
        return this.shengjiForm.coupon
      }
    },
    watch:{
      region(){
        this.getPrice()
      },
      coupon(){
        this.getPrice()
      },
      coupon2(){
        this.levelPrice()
      }
    },
    methods:{
      ...mapActions(['VHOST']),
      async SearchVhost() {
        this.listLoading = true
        let data = 'cmd=vhost_list'+
          '&count='+ this.count +
          '&page='+ this.page +
          '&key_type='+ this.key_type +
          '&keyword='+ this.search +
          '&orderby='+ this.orderby +
          '&ordertype='+ this.ordertype
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total = vueData.msg.allcount
          this.vhostList = vueData.msg.content.map((item, index) => {
            return {
              id:item.id,
              Pstate:item.Pstate,
              domainname:item.domainname,
              StartTime:item.StartTime,
              EndTime:item.EndTime,
              websize:item.websize,
              ip_type:item.ip_type,
              mysql:item.mysql,
              daikuan:item.daikuan,
              system:item.system,
              mssql:item.mssql,
              liuliang:item.liuliang,
              free:item.free,
              ip: item.ip_type === '共享' ? item.ip : item.ip_bind
            }
          })
          this.showempty = true
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      sort(obj){
        switch (obj.prop) {
          case 'StartTime':
            this.orderby = 'StartTime'
            break
          case 'EndTime':
            this.orderby = 'EndTime'
            break
        }
        switch (obj.order) {
          case 'ascending':
            this.ordertype = 'asc'
            break
          case 'descending':
            this.ordertype = 'desc'
            break
        }
        this.SearchVhost()
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SearchVhost()
      },
      handleSizeChange(val) {
        this.count = val
        this.SearchVhost()
      },
      Rennew(id,endtime) {
        this.xufeiForm.id = id
        this.xufeiForm.endtime = endtime

        this.couponInfo()
        this.getPrice()
      },
      async Shengji(id,endtime,websize,daikuan,mysql,mssql) {
        this.shengjiForm.id = id
        this.shengjiForm.endtime = endtime
        this.shengjiForm.websize = websize
        this.shengjiForm.daikuan = daikuan.replace('(','').replace(')','')
        this.shengjiForm.mysql = mysql
        this.shengjiForm.mssql = mssql
        await this.levelShow()
        await this.levelPrice()
        if(!this.shengjiForm.loading === true){
          this.dialogXLevel = true
          this.couponInfo()
        }
      },
      changeConfig(view) {
        this.levelPrice()
      },
      BuyVhost () {
        window.open("https://www.abeiyun.com/vhost/")
      },
      async HostInit(id){
        this.dialogLoading = true
        let data = 'cmd=host_init'+
          '&id='+ id
        let {vueData, state} = await vhostService.transformToVue('vhostInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.SearchVhost()}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async couponInfo() {
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=userinfo')
        if(state.code === '000' ) {
          this.xufeiForm.money = vueData.msg.money
          this.shengjiForm.money = vueData.msg.money
          this.shengjiForm.yhq = vueData.msg.yhq.onuse.map((item, index) => {
            return {
              value: item.yhq_id,
              label: item.yhq_id+'(可优惠'+ item.money_all +'元，最低消费满'+ item.money_need +'元可使用)',
              yhq_use: item.yhq_use
            }
          })
          this.xufeiForm.yhq = vueData.msg.yhq.onuse.map((item, index) => {
            return {
              value: item.yhq_id,
              label: item.yhq_id+'(可优惠'+ item.money_all +'元，最低消费满'+ item.money_need +'元可使用)',
              yhq_use: item.yhq_use
            }
          })
          this.xufeiForm.yhq.unshift({
            value: '',
            label: '不使用优惠券',
            yhq_use: ''
          })
          this.shengjiForm.yhq.unshift({
            value: '',
            label: '不使用优惠券',
            yhq_use: ''
          })
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      async getPrice() {
        this.xufeiForm.loading = true
        let data = 'cmd=renew'+
          '&yewu_type=vhost'+
          '&yewu_id='+ this.xufeiForm.id +
          '&renew_time='+ this.xufeiForm.region +
          '&yhq_id='+ this.xufeiForm.coupon +
          '&ac_type=getprice'
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogXufei = true
          this.xufeiForm.loading = false
          this.xufeiForm.name = vueData.pname
          this.xufeiForm.ftp = vueData.ftp_user
          this.xufeiForm.newtime = vueData.endtime
          this.xufeiForm.price = vueData.price
        }else {
          let self = this
          this.$dialog({type:'error', info: vueData.msg, click () {
            self.xufeiForm.coupon = ''
          }})
        }
      },
      async Renew() {
        this.dialogLoading = true
        let data = 'cmd=renew'+
          '&yewu_type=vhost'+
          '&yewu_id='+ this.xufeiForm.id +
          '&renew_time='+ this.xufeiForm.region +
          '&yhq_id='+ this.xufeiForm.coupon +
          '&ac_type=renew'
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
            self.dialogXufei = false
            self.SearchVhost()
          }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async levelShow() {
        let data = 'cmd=vhost_show'+
          '&yewu_id='+ this.shengjiForm.id
        let {vueData, state} = await upgradeService.transformToVue('upgradeInfo','POST',data)
        if(vueData.response == 200 ) {
          this.shengjiForm.type = vueData.msg[0].id
          this.shengjiForm.config = vueData.msg.map((item, index) => {
            return {
              value: item.id,
              label: item.pname,
            }
          })
        }
      },
      async levelPrice() {
        this.shengjiForm.loading = true
        let data = 'cmd=vhost_price'+
          '&yewu_id='+ this.shengjiForm.id +
          '&new_type_id='+ this.shengjiForm.type +
          '&yhq_id='+ this.shengjiForm.coupon
        let {vueData, state} = await upgradeService.transformToVue('upgradeInfo','POST',data)
        if(vueData.response == 200 ) {
          this.shengjiForm.loading = false
          this.shengjiForm.pset = vueData.pset
          this.shengjiForm.price = vueData.msg
        }else {
          let self = this
          this.$dialog({type:'error', info: vueData.msg, click () {
              self.shengjiForm.coupon = ''
            }})
        }
      },
      async Level() {
        this.dialogLoading = true
        let data = 'cmd=vhost_upgrade'+
          '&yewu_id='+ this.shengjiForm.id +
          '&new_type_id='+ this.shengjiForm.type +
          '&yhq_id='+ this.shengjiForm.coupon
        let {vueData, state} = await upgradeService.transformToVue('upgradeInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.dialogXLevel = false
              self.SearchVhost()
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }
  .xufei-form .el-input,.el-select {
    width: 140px;
  }
  .input-with-select .el-input-group__prepend .el-select {
    width: 100px;
  }
  .ver-sub { vertical-align: sub; }
  .alert-warn {
    margin-bottom: 20px;
  }
  .alert-warn.alert-white-bg {
    border: none;
    padding: 0px;
    background: #fff;
    line-height: 2em;
    color: #aaa;
  }
  .alert-warn.alert-white-bg .alert-warn-title {
    color: #ff8800;
  }
  .vhost-free {
    position: absolute;
    right: 26%;
    top: 30%;
    display: inline-block;
    width: 29px;
    height: 23px;
    background: url(../../assets/imgs/free.gif) no-repeat center;
  }
</style>




// WEBPACK FOOTER //
// src/pages/product/vhostList.vue